export const ScenarioConventionOption = [
  { id: 'english', displayLabel: 'English', value: 'english' },
  { id: 'gherkin', displayLabel: 'Gherkin', value: 'gherkin' }
  // { id: 'bdd', displayLabel: 'BDD', value: 'bdd' }
];
export const ScenarioTypeOption = [
  { id: 'positive', displayLabel: 'Positive', value: 'positive' },
  { id: 'negative', displayLabel: 'Negative', value: 'negative' },
  { id: 'both', displayLabel: 'Both', value: 'both' }
];
export const startFromOption = [
  { id: 'api', displayLabel: 'API', value: 'api', checked: false},
  { id: 'web', displayLabel: 'Web', value: 'web', checked: false },
  { id: 'mobile', displayLabel: 'Mobile', value: 'mobile', checked: false },
];
export const automationToolsWeb = [
  { id: 'playwright', displayLabel: 'Playwright', value: 'playwright' },
  { id: 'selenium', displayLabel: 'Selenium', value: 'selenium' }
];
export const automationToolsMobile = [
  { id: 'appium', displayLabel: 'Appium', value: 'appium' },
  { id: 'detox', displayLabel: 'Detox', value: 'detox' }
];
export const FrameworkAllOption = {
  java:[
    { id: 'junit', displayLabel: 'JUnit', value: 'junit' },
    { id: 'testng', displayLabel: 'TestNG', value: 'testng' },
    { id: 'rest-assured', displayLabel: 'Rest Assured', value: 'rest-assured' },
    { id: 'karate', displayLabel: 'Karate', value: 'karate' },
    { id: 'spock', displayLabel: 'Spock', value: 'spock' }
  ],
  javascript: [
    { id: 'jest', displayLabel: 'Jest', value: 'jest' },
    { id: 'mocha', displayLabel: 'Mocha', value: 'mocha' },
    { id: 'chai', displayLabel: 'Chai', value: 'chai' },
    { id: 'supertest', displayLabel: 'Supertest', value: 'supertest' },
    { id: 'webdriverio-pageobject', displayLabel: 'WebdriverIO (PageObject)', value: 'webdriverio-pageobject' },
    { id: 'webdriverio-cucumber', displayLabel: 'WebdriverIO (Cucumber)', value: 'webdriverio-cucumber' }
  ],
  python: [
    { id: 'unittest', displayLabel: 'unittest', value: 'unittest' },
    { id: 'pytest', displayLabel: 'pytest', value: 'pytest' },
    { id: 'nose2', displayLabel: 'nose2', value: 'nose2' }
  ],
  typescript: [
    { id: 'jest', displayLabel: 'Jest', value: 'jest' },
    { id: 'supertest', displayLabel: 'Supertest', value: 'supertest' },
    { id: 'playwright', displayLabel: 'Playwright', value: 'playwright' },
    { id: 'webdriverio-pageobject', displayLabel: 'WebdriverIO (PageObject)', value: 'webdriverio-pageobject' },
    { id: 'webdriverio-cucumber', displayLabel: 'WebdriverIO (Cucumber)', value: 'webdriverio-cucumber' }
  ],
  groovy: [
    { id: 'spock', displayLabel: 'Spock', value: 'spock' },
    { id: 'geb', displayLabel: 'Geb', value: 'geb' }
  ],
  dotnet: [
    { id: 'xunit', displayLabel: 'xUnit', value: 'xunit' },
    { id: 'nunit', displayLabel: 'NUnit', value: 'nunit' },
    { id: 'mstest', displayLabel: 'MSTest', value: 'mstest' }
  ],
  CSharp: [
    { id: 'xunit', displayLabel: 'xUnit', value: 'xunit' },
    { id: 'nunit', displayLabel: 'NUnit', value: 'nunit' },
    { id: 'mstest', displayLabel: 'MSTest', value: 'mstest' }
  ],
  Kotlin: [
    { id: 'kotest', displayLabel: 'Kotest', value: 'kotest' },
    { id: 'spek', displayLabel: 'Spek', value: 'spek' },
    { id: 'junit-5', displayLabel: 'JUnit 5', value: 'junit-5' },
    { id: 'ktor-test', displayLabel: 'Ktor Test', value: 'ktor-test' }
  ]
}
export const ProgrammingLanguageOption = [
  { id: 'java', displayLabel: 'Java', value: 'java' },
  { id: 'python', displayLabel: 'Python', value: 'python' },
  { id: 'Kotlin', displayLabel: 'Kotlin', value: 'Kotlin' },
  { id: 'CSharp', displayLabel: 'CSharp', value: 'CSharp' },
  { id: 'typescript', displayLabel: 'Typescript', value: 'typescript' },
  { id: 'javascript', displayLabel: 'Javascript', value: 'javascript' },
  { id: 'groovy', displayLabel: 'Groovy', value: 'groovy' },
  { id: 'dotnet', displayLabel: 'dotnet', value: 'dotnet' }
];
export const TestConventionOption = [
  {
    id: 'givenXXX_whenXXX_thenXX',
    displayLabel: 'BDD',
    value: 'givenXXX_whenXXX_thenXX'
  },
  // {
  //   id: 'Should_ExpectedBehavior_When_StateUnderTest',
  //   displayLabel: 'Should_ExpectedBehavior_When_StateUnderTest',
  //   value: 'Should_ExpectedBehavior_When_StateUnderTest'
  // },
  {
    id: 'data-driven-testing',
    displayLabel: 'Data Driven',
    value: 'data-driven-testing'
  }
];
export const automationToolsMobileOption = {
  appium:{
    programmingLanguages: [
      { id: 'java', displayLabel: 'Java', value: 'java' },
      { id: 'python', displayLabel: 'Python', value: 'python' },
      { id: 'javascript', displayLabel: 'JavaScript', value: 'javascript' }
    ],
    testConventions: [
      { id: 'page-object', displayLabel: 'Page Object', value: 'page-object' },
      { id: 'hybrid', displayLabel: 'Hybrid', value: 'hybrid' }
    ],
    frameworks: [
      { id: 'junit', displayLabel: 'JUnit', value: 'junit' },
      { id: 'testng', displayLabel: 'TestNG', value: 'testng' },
      { id: 'mocha', displayLabel: 'Mocha', value: 'mocha' }
    ],
    uiFrameworks: [
      { id: 'flutter', displayLabel: 'Flutter', value: 'flutter' },
      { id: 'react-native', displayLabel: 'React Native', value: 'react-native' },
      { id: 'native-android', displayLabel: 'Native Android', value: 'native-android' }
    ],
    browsersOrDevices: [
      { id: 'android-emulator', displayLabel: 'Android Emulator', value: 'android-emulator' },
      { id: 'ios-simulator', displayLabel: 'iOS Simulator', value: 'ios-simulator' },
      { id: 'real-device', displayLabel: 'Real Device', value: 'real-device' }
    ]
  },
  detox: {
    programmingLanguages: [
      { id: 'javascript', displayLabel: 'JavaScript', value: 'javascript' },
      { id: 'typescript', displayLabel: 'TypeScript', value: 'typescript' }
    ],
    testConventions: [
      { id: 'functional', displayLabel: 'Functional', value: 'functional' },
      { id: 'bdd', displayLabel: 'BDD', value: 'bdd' }
    ],
    frameworks: [
      { id: 'mocha', displayLabel: 'Mocha', value: 'mocha' },
      { id: 'jest', displayLabel: 'Jest', value: 'jest' }
    ],
    uiFrameworks: [
      { id: 'react-native', displayLabel: 'React Native', value: 'react-native' }
    ],
    browsersOrDevices: [
      { id: 'ios-simulator', displayLabel: 'iOS Simulator', value: 'ios-simulator' },
      { id: 'android-emulator', displayLabel: 'Android Emulator', value: 'android-emulator' }
    ]
  }
}
export const automationToolsWebOption = {
 playwright: {
    programmingLanguages: [
      { id: 'javascript', displayLabel: 'JavaScript', value: 'javascript' },
      { id: 'typescript', displayLabel: 'TypeScript', value: 'typescript' },
      { id: 'python', displayLabel: 'Python', value: 'python' },
      { id: 'java', displayLabel: 'Java', value: 'java' }
    ],
    testConventions: [
      { id: 'bdd', displayLabel: 'BDD', value: 'bdd' },
      { id: 'page-object', displayLabel: 'Page Object', value: 'page-object' },
      { id: 'data-driven', displayLabel: 'Data-Driven', value: 'data-driven' }
    ],
    frameworks: [
      { id: 'mocha', displayLabel: 'Mocha', value: 'mocha' },
      { id: 'jest', displayLabel: 'Jest', value: 'jest' },
      { id: 'pytest', displayLabel: 'PyTest', value: 'pytest' },
      { id: 'junit', displayLabel: 'JUnit', value: 'junit' }
    ],
    uiFrameworks: [
      { id: 'react', displayLabel: 'React', value: 'react' },
      { id: 'angular', displayLabel: 'Angular', value: 'angular' },
      { id: 'vue', displayLabel: 'Vue', value: 'vue' }
    ],
    browsersOrDevices: [
      { id: 'chrome', displayLabel: 'Chrome', value: 'chrome' },
      { id: 'firefox', displayLabel: 'Firefox', value: 'firefox' },
      { id: 'edge', displayLabel: 'Edge', value: 'edge' }
    ]
  },
  selenium:{
    programmingLanguages: [
      { id: 'java', displayLabel: 'Java', value: 'java' },
      { id: 'python', displayLabel: 'Python', value: 'python' },
      { id: 'csharp', displayLabel: 'C#', value: 'csharp' }
    ],
    testConventions: [
      { id: 'page-object', displayLabel: 'Page Object', value: 'page-object' },
      { id: 'keyword-driven', displayLabel: 'Keyword-Driven', value: 'keyword-driven' }
    ],
    frameworks: [
      { id: 'testng', displayLabel: 'TestNG', value: 'testng' },
      { id: 'junit', displayLabel: 'JUnit', value: 'junit' },
      { id: 'nunit', displayLabel: 'NUnit', value: 'nunit' }
    ],
    uiFrameworks: [
      { id: 'any', displayLabel: 'Any', value: 'any' }
    ],
    browsersOrDevices: [
      { id: 'chrome', displayLabel: 'Chrome', value: 'chrome' },
      { id: 'firefox', displayLabel: 'Firefox', value: 'firefox' },
      { id: 'edge', displayLabel: 'Edge', value: 'edge' },
      { id: 'safari', displayLabel: 'Safari', value: 'safari' }
    ]
  }
}

